import styled from 'styled-components';

export const CardsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;

  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`;

export const StyledText = styled.text`
  font-size: ${({ size }) => (size ? '24px' : '20px')};
  font-weight: ${({ bold }) => (bold ? 'bold' : 'normal')};
  margin-left: ${({ left }) => (left ? 'auto' : 'none')};
`;

export const Container = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;

  .count-card-container {
    margin: 65px 0px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
`;

export const CountCard = styled.div`
  color: #fff;
  background: #002666;
  width: 30%;
  height: 240px;
  padding: 35px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  transition: 0.5s;

  :hover {
    opacity: 0.6;
  }

  .count-stats {
    margin: 0px;
    font-size: 40px;
    font-weight: bold;
  }

  .count-card-top {
    display: flex;
    align-items: flex-start;
    flex-direction: row;
    justify-content: space-between;
  }
  .count-card-top-left {
    display: flex;
    align-items: flex-end;
    flex-direction: row;
  }
  .count-card-date {
    font-size: 20px;
    margin: 0px 20px;
  }

  .count-card-main-icon {
    font-size: 40px;
  }

  .count-card-caret-down {
    font-size: 40px;
  }
  .count-card-cog {
    font-size: 35px;
    position: relative;
    top: -20px;
    left: 20px;
  }

  .count-card-bot {
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    justify-content: space-between;
  }

  .half-opacity {
    color: rgba(255, 255, 255, 0.5);
  }
`;
export const TableContainer = styled.div`
  border: 1px solid #dde4ed;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  .table-title-container {
    border-bottom: 3px solid #dde4ed;
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    justify-content: space-between;
    margin: 20px;
  }
  h1 {
    color: #002666;
    display: inline;
  }
  th {
    font-weight: bold;
    text-align: left;
    padding: 10px;
  }
  tr {
  }
  td {
    text-align: left;
    padding: 10px;
  }
  td text {
    color: ${({ red }) => (red ? 'blue' : 'red')};
    margin-left: 20px;
  }
  .red {
    color: ${({ red }) => (red ? 'red' : 'blue')};
  }
  span {
    color: #a3a3a3;
    margin-bottom: 8px;
  }
`;
